/** add-event-listener **/

window.scrollPreventer = window.scrollPreventer || {};

// detect passive events
var passive = false

try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function() {
      passive = true
    }
  })

  window.addEventListener('test', null, opts)
  window.removeEventListener('test', null, opts)
} catch(e) {
  passive = false
}


var Events = null
const events = {}

function addEventListener(el, eventName, listener, useCapture) {
  Events = Events || (
    document.addEventListener ?
    {add: stdAttach, rm: stdDetach} :
    {add: oldIEAttach, rm: oldIEDetach}
  )

  return Events.add(el, eventName, listener, useCapture)
}

events.addEventListener = addEventListener;

function removeEventListener(el, eventName, listener, useCapture) {
  Events = Events || (
    document.addEventListener ?
    {add: stdAttach, rm: stdDetach} :
    {add: oldIEAttach, rm: oldIEDetach}
  )

  return Events.rm(el, eventName, listener, useCapture)
}

events.removeEventListener = removeEventListener;

function stdAttach(el, eventName, listener, useCapture) {
  el.addEventListener(eventName, listener, passive ? useCapture : !!useCapture)
}

function stdDetach(el, eventName, listener, useCapture) {
  el.removeEventListener(eventName, listener, passive ? useCapture : !!useCapture)
}

function oldIEAttach(el, eventName, listener, useCapture) {
  if(useCapture) {
    throw new Error('cannot useCapture in oldIE')
  }

  el.attachEvent('on' + eventName, listener)
}

function oldIEDetach(el, eventName, listener, useCapture) {
  el.detachEvent('on' + eventName, listener)
}

/** END add-event-listener **/

/** traversing **/

/**
 * Converts els into an array.
 *
 * @function makeArray
 * @param {(Array.<HtmlElement>|HtmlElement)} els
 * @returns {Array.<HtmlElement>}
 */
function makeArray (els) {
  if (els === undefined || els === null) {
    return []
  }

  // Some elements can be iterable, for example forms and selects. We
  // specifically check whether els is a DOM node.
  let arr
  if (els.nodeType) {
    arr = [els]
  } else {
    arr = Array.from(els)
  }

  if (!arr.length && els && els.length === undefined) {
    arr = [els]
  }

  return arr
}

/**
 * Calls fn for each element in els
 *
 * @function forEach
 * @param {(Array.<HtmlElement>|HtmlElement)} els
 * @param {function} fn
 */
function forEach (els, fn) {
  const arr = makeArray(els)
  arr.forEach(fn)
}

/** END traversing **/

/** events **/

/**
 * Adds an event listener to each of els, calling handler upon the specified
 * event for each of els.
 *
 * @function addListener
 * @param {(Array.<HtmlElement>|HtmlElement)} els
 * @param {string} eventNames
 * @param {function} handler
 */
function addListener (els, eventNames, handler, opts = {}) {
  if (els.nodeType || els === window) {
    els = [els]
  }

  eventNames.split(' ').forEach(eventName =>
    forEach(els, el => events.addEventListener(el, eventName, handler, opts)))
}

/**
 * Removes an event listener from each of els.
 *
 * @function removeListener
 * @param {(Array.<HtmlElement>|HtmlElement)} els
 * @param {string} eventNames
 * @param {function} [handler]
 */
function removeListener (els, eventNames, handler, opts = {}) {
  if (els.nodeType || els === window) {
    els = [els]
  }

  eventNames.split(' ').forEach(eventName =>
    forEach(els,
      el => events.removeEventListener(el, eventName, handler, opts)))
}

/**
 * Triggers the named event for each of els.
 *
 * @function triggerEvent
 * @param {(Array.<HtmlElement>|HtmlElement)} els
 * @param {string} eventName
 * @param {Object} [opts]
 */
function triggerEvent (els, eventName, opts = {
  bubbles: false, cancelable: false, detail: undefined
}) {
  if (els.nodeType || els === window) {
    els = [els]
  }

  const evt = document.createEvent('CustomEvent')
  evt.initCustomEvent(eventName, opts.bubbles, opts.cancelable,
    opts.detail)

  forEach(els, el => {
    el.dispatchEvent(evt)
  })
}

/** END events **/

/** init **/

function emptyObject (obj) {
  for (var prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) { return false }
  }
  return true
}

/** END init **/

/**
 * @class ScrollPreventer
 *
 * Controls the ability of the user to scroll the page.
 *
 * Preventing scroll on the body element is a bit complex. This module:
 * 1. Sets a class on the html element (and therefore requires use of
 *    scrolling.scss) which sets overflow on the html element etc such that
 *    scroll is prevented on desktop.
 * 2. Conditionally prevents touchmove to ensure scroll is prevented on mobile
 *    devices. See docstrings for constructor and preventScroll. Not that this
 *    requires use of a non-passive event listener.
 * 3. Prevents an overscroll related bug on iOS, see preventbodyBounce
 *    docstring.
 *
 * This module avoids the body scroll position changing (as would happen if the
 * html element was set to position: fixed, a common approach to solving this
 * problem).
 *
 * Upon calling preventScroll, scroll will be prevented until allowScroll
 * has been called passing in all keys that were provided to preventScroll,
 * thus it is possible to prevent scroll for multiple reasons and have scroll
 * continue to be prevented until all of those reasons have ceased to exist.
 *
 * TODO: Finish extending this so it functions on any element (eg.
 * prevent-scroll class is not always set on body).
 */
class ScrollPreventer {
  /**
   * Constructs an instance of ScrollPreventer.
   *
   * Some mobile devices (primarily iOS) ignore overflow hidden on the html
   * element, so this constructor assigns a handler that prevents default for
   * all touchmove events on body if scroll prevention has been requested.
   * Any element that the user is permitted to scroll must be passed to
   * preventScroll.
   *
   * @constructs ScrollPreventer
   */
  constructor () {
    this.preventions = {}
    this.active = false
    this.boundPreventTouch = this.preventTouch.bind(this)

    addListener(document.body, 'touchmove', this.boundPreventTouch, {
      passive: false
    })
  }

  /**
   * Event handler that simply prevents default if this is active.
   *
   * @method ScrollPreventer#preventTouch
   * @param {Event} e
   */
  preventTouch (e) {
    if (this.active) {
      e.preventDefault()
    }
  }

  /**
   * Event handler that simply stops propogation. Abstracted into its own
   * method so the handler can be added and removed easily.
   *
   * @method ScrollPreventer#preventBubble
   * @param {Event} e
   */
  preventBubble (e) {
    e.stopPropagation()
  }

  /**
   * iOS has a bug where overscroll will be applied to the body instead of the
   * permitted element if the permitted element is at scroll position 0 or
   * scrollHeight. We prevent this by using this scroll handler to
   * ensure that the permitted element can only be scrolled between 1 and its
   * scrollHeight - 1.
   *
   * @method ScrollPreventer#preventBodyBounce
   * @param {Event} e
   */
  preventBodyBounce (e) {
    const target = e.target || e.srcElement
    if (target.scrollTop <= 0) {
      target.scrollTo(0, 1)
    } else if (target >= target.scrollHeight) {
      target.scrollTo(0, target.scrollHeight - 1)
    }
  }

  /**
   * Requests that scroll be prevented until allowScroll is called passing in a
   * matching key.
   *
   * Any elements that are permitted to scroll during this time (eg. an
   * overlay) must be passed to this method and will have a touchmove handler
   * assigned which stops propogation, thus the handler on body that prevents
   * touchmove will never be called.
   *
   * @method ScrollPreventer#preventScroll
   * @param {string} key
   * @param {(Array.<HtmlElement>|HtmlElement)} scrollableEls
   */
  preventScroll (key, scrollableEls = []) {
    forEach(scrollableEls, scrollableEl => {
      addListener(scrollableEl, 'touchmove', this.preventBubble, {
        passive: true
      })
      addListener(scrollableEl, 'scroll', this.preventBodyBounce, {
        passive: true
      })
      this.preventBodyBounce({
        target: scrollableEl
      })
    })
    this.preventions[key] = scrollableEls
    this.active = true
    document.documentElement.classList.add('disable-scroll')
  }

  /**
   * Removes the given key from the list of preventions and removes handlers
   * from any permitted elements, then reenables scroll if no other keys have
   * requested it.
   *
   * @method ScrollPreventer#allowScroll
   * @param {string} key
   */
  allowScroll (key) {
    forEach(this.preventions[key], scrollableEl => {
      removeListener(scrollableEl, 'touchmove', this.preventBubble, {
        passive: true
      })
      removeListener(scrollableEl, 'scroll', this.preventBodyBounce, {
        passive: true
      })
    })
    delete this.preventions[key]
    this.active = !emptyObject(this.preventions)
    if (!this.active) {
      document.documentElement.classList.remove('disable-scroll')
    }
  }

  teardown (els) {
    removeListener(document.body, 'touchmove', this.boundPreventTouch, {
      passive: false
    })
  }
}

const getScrollPreventer = (...loadArgs) => {
  return new ScrollPreventer(...loadArgs)
}

window.scrollPreventer = getScrollPreventer()
